/** Aba reordenável compartilhada; somente a alça inicia o arraste. */
import type { ReactNode } from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { GripVertical } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';

export function SortableCategoryTab({ id, disabled, children }: { id: string; disabled: boolean; children: ReactNode }) {
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({ id, disabled });
  
  return (
    <div 
      ref={setNodeRef} 
      style={{ transform: CSS.Transform.toString(transform), transition }} 
      className={cn(
        "relative group",
        isDragging && "z-20 opacity-60"
      )}
    >
      {!disabled && (
        <Button 
          variant="ghost" 
          size="icon" 
          className={cn(
            // A alça da aba permanece disponível, sem competir com o título.
            "absolute left-0 top-1/2 z-10 h-6 w-5 -translate-y-1/2 cursor-grab text-muted-foreground/40",
            "hover:text-muted-foreground/60 hover:bg-muted/50"
          )}
          aria-label="Arraste para reordenar a categoria" 
          title="Arraste para reordenar" 
          {...attributes} 
          {...listeners} 
          onClick={e => e.stopPropagation()}
        >
          <GripVertical className="h-3.5 w-3.5" />
        </Button>
      )}
      {children}
    </div>
  );
}
